import {postRequest,postRequestSearch} from "./helper"
export const getProfile = (data) => postRequest('profile',data);
export const updateProfile = (data) => postRequest('user-update',data);
export const deActivateAccountApi = (data) => postRequest('change-profile-status',data);
export const getUserUrl = (data) => postRequestSearch('getCheckUserUrl',data);
export const updateUserUrl = (data) => postRequest('userUrlUpdate',data);





// WEBPACK FOOTER //
// ./src/api/Profile.js